import { lazy } from 'react';

import type { ModuleWeb } from '../registry.js';

/**
 * Écrans du module Opérations (spec 004), chargés à la demande ; chaque écran revérifie ses
 * droits côté serveur. Révision du référent (2026-10-31) : la vue d'ensemble, les demandes de
 * poste, la passerelle e-Protec et l'institutionnel sont retirés. Le catalogue et le planning
 * des dotations restent servis hors menu (liens de la liste des activités) tant que le
 * matériel n'est pas transféré à la Logistique, dont le planning des réservations fait foi.
 */
const page = <T extends string>(
  load: () => Promise<Record<T, () => React.ReactElement>>,
  name: T,
) => lazy(() => load().then((m) => ({ default: m[name] })));

const ActivitiesPage = page(() => import('./activities/ActivitiesPages.js'), 'ActivitiesPage');
const ActivityPage = page(() => import('./activities/ActivitiesPages.js'), 'ActivityPage');
const ResourcesPage = page(() => import('./activities/ActivitiesPages.js'), 'ResourcesPage');
const PlanningPage = page(() => import('./documents/DocumentsPages.js'), 'PlanningPage');
const MyReportsPage = page(() => import('./documents/DocumentsPages.js'), 'MyReportsPage');
const DocumentSettingsPage = page(
  () => import('./documents/DocumentsPages.js'),
  'DocumentSettingsPage',
);
const AdminPage = page(() => import('./OperationsPages.js'), 'AdminPage');
const EprotecPage = page(() => import('./EprotecPage.js'), 'EprotecPage');

export const operationsWeb: ModuleWeb = {
  module: 'operations',
  routes: [
    { path: '/operations/activites', element: <ActivitiesPage /> },
    { path: '/operations/activites/:id', element: <ActivityPage /> },
    { path: '/operations/dotations', element: <ResourcesPage /> },
    { path: '/operations/dotations/planning', element: <PlanningPage /> },
    { path: '/operations/comptes-rendus', element: <MyReportsPage /> },
    { path: '/operations/admin/documents', element: <DocumentSettingsPage /> },
    { path: '/operations/admin', element: <AdminPage /> },
    { path: '/operations/eprotec', element: <EprotecPage /> },
  ],
};
